import React, { Component } from 'react'
import translate from 'react-i18next/dist/commonjs/translate';

class Allotmentrender extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            allotment: null,
          };
        
      }

      componentDidMount () {
          this.setState({
              allotment: this.props.data.allotment_status,
          })
          console.log(this.state.allotment);
      }
    
    render() {
        const { t } = this.props;
        const { allotment } = this.props
        return (
            <div>
                <span>{this.props.data.allotment_status != null ? (this.props.data.allotment_status.allotment_text) : (<>{t("table_view.create") || "CREATED"}</>)}</span>
            </div>
        )
    }
}
export default translate('orders')(Allotmentrender)
